/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagerefundednone3Inputs */

const en_ticketpagerefundednone3 = /** @type {(inputs: Ticketpagerefundednone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No refunds`)
};

const de_ticketpagerefundednone3 = /** @type {(inputs: Ticketpagerefundednone3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Erstattungen`)
};

/**
* | output |
* | --- |
* | "No refunds" |
*
* @param {Ticketpagerefundednone3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagerefundednone3 = /** @type {((inputs?: Ticketpagerefundednone3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagerefundednone3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagerefundednone3(inputs)
	return de_ticketpagerefundednone3(inputs)
});
export { ticketpagerefundednone3 as "ticketPageRefundedNone" }